import { render, staticRenderFns } from "./ChemicalStaticList.vue?vue&type=template&id=46c63f5b&scoped=true&"
import script from "./ChemicalStaticList.vue?vue&type=script&lang=js&"
export * from "./ChemicalStaticList.vue?vue&type=script&lang=js&"
import style0 from "./ChemicalStaticList.vue?vue&type=style&index=0&id=46c63f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c63f5b",
  null
  
)

export default component.exports